
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, LookupCriteria, LookupItemViewModel } from "@tylertech/tyler-api-types";

/**
 * ProjectTypeLookupService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProjectTypeLookupService {
    constructor(private readonly $apiService: ApiService) { }
    
    Lookup(pCriteria: LookupCriteria): Promise<LookupItemViewModel[]> {
        return this.$apiService.sendAuth("IProjectTypeLookupService/Lookup", pCriteria);
    }
}
